import React from "react";

const Map = () => {
  return (
    <div className="    ">
      <iframe
        className="broder   lg:w-[500px] md:w-[350px] py-8 rounded  h-96  "
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14603.042712100108!2d90.4186963!3d23.7915351!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa5998bedeec72a77!2sHealthCare%20At%20Home%20Bangladesh!5e0!3m2!1sen!2sbd!4v1666516296223!5m2!1sen!2sbd"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Map;
